"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectorTypes = void 0;
var ConnectorTypes;
(function (ConnectorTypes) {
    ConnectorTypes["WEB"] = "WEB";
    ConnectorTypes["POS"] = "POS";
    ConnectorTypes["BORNE"] = "BORNE";
    ConnectorTypes["HUBRISE"] = "HUBRISE";
    ConnectorTypes["PREVIEW"] = "PREVIEW";
})(ConnectorTypes || (exports.ConnectorTypes = ConnectorTypes = {}));
